
import axios from './rest-axios';

const getMembershipType = (id) => axios.get(`/manage/membership_type`, {id});
const postMembershipType = (model) => axios.post(`/manage/membership_type`, model);
const putMembershipType = (model) => axios.put(`/manage/membership_type/${model.id}`, model);

export {
    getMembershipType,
    postMembershipType,
    putMembershipType,
};
